import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Logger } from 'shared';
import { ImpersonationService } from '../../services/impersonation.service';

const logger = new Logger('impersonationInterceptor');

/**
 * Interceptor to add impersonation token to all HTTP requests
 */
export const impersonationInterceptor: HttpInterceptorFn = (req, next) => {
  const impersonationService = inject(ImpersonationService);
  const token = impersonationService.getToken();

  logger.debug('impersonationInterceptor:', req.url, 'token:', token ? token.substring(0, 10) + '...' : 'null');

  // Only add header if actively impersonating
  if (token) {
    const clonedReq = req.clone({
      setHeaders: {
        'X-Impersonation-Token': token
      }
    });
    logger.debug('impersonationInterceptor: Added X-Impersonation-Token header to', req.url);
    return next(clonedReq);
  }

  return next(req);
};
